<script lang="ts">
	import ChromosomeHero from "@components/ChromosomeHero.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonSize, ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import { Chromosome } from "@core/schema/Chromosome.js";
	import { categoryNameMap } from "@core/schema/names/categoryNameMap.js";
	import { getProductPath } from "@core/schema/paths/getProductPath.js";
	import { getSubcategoryPath } from "@core/schema/paths/getSubcategoryPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { CategoryProps } from "./CategoryProps.js";

	const { products, subcategories, category }: CategoryProps = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<Layout>
	<section class="order-2 pt-8 lg:pt-20">
		<h2 class="text-blue"><Formatted text={categoryNameMap[category][tenant.locale]} /></h2>
	</section>
	<div class="order-1 grid-container full-width"><ChromosomeHero /></div>
	<section class="order-3 pb-24 w-full">
		<div class="flex flex-col lg:flex-row gap-8 pt-20">
			<div>
				<span class="text-blue font-medium text-md mb-4 block">Filtrovat dle podkategorie</span>

				<div class="flex flex-wrap flex-col mb-12 bg-white rounded-lg">
					{#each subcategories as subcategory (subcategory.id)}
						{#if products.some((product) => product.subcategory === subcategory.id)}
							<a
								href={getSubcategoryPath(tenant, subcategory)}
								class="first:pt-4 last:pb-4 hover:text-blue transition-all duration-300 border-y border-gray-100 py-2 text-gray-800 px-3.5"
							>
								{subcategory.name[tenant.locale]}
							</a>
						{/if}
					{/each}
				</div>
			</div>
			<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 flex-wrap gap-3">
				{#each products as product (product.id)}
					<div
						class="p-4 border-2 border-white hover:border-lightblue transition-all duration-300 bg-white flex flex-col justify-between rounded-xl gap-2 max-w-80 max-h-56"
					>
						<div class="flex flex-col gap-2">
							<span class="text-md font-medium min-h-10">{product.name[tenant.locale]}</span>
							<div class="flex gap-2 items-start">
								{#if product.locations.some((location) => Object.values(Chromosome).includes(location.chromosome))}
									<span class="text-xs leading-6">Sondy:</span>
								{/if}
								<div class="flex gap-0.5 flex-wrap">
									{#each Object.values(Chromosome).filter( (chromosome) => product.locations.some((location) => location.chromosome === chromosome), ) as chromosome (chromosome)}
										<span class="px-2.5 text-xs py-1 leading-tight rounded-full bg-lightblue">{chromosome}</span>
									{/each}
								</div>
							</div>
						</div>
						<Link
							class="self-end"
							variant={ButtonVariant.Outline}
							size={ButtonSize.Sm}
							href={getProductPath(tenant, product)}>Detail</Link
						>
					</div>
				{:else}
					<p>Žádné produkty.</p>
				{/each}
			</div>
		</div>
	</section>
</Layout>
